/**
 * Bloque unificado propietarios + contactos asociados (vista previa).
 * Muestra quién lleva la comunicación (mismo criterio que columna Com. en ficha).
 */
export function FichaResumenPropietariosContactos({ datos, theme }) {
  const t = theme?.colors || {};
  const propietarios = Array.isArray(datos?.propietarios) ? datos.propietarios : [];
  const contactos = Array.isArray(datos?.contactos_asociados) ? datos.contactos_asociados : [];
  const comId = datos?.contacto_comunicacion_id || null;

  const filas = [
    ...propietarios.map((p) => ({
      key: `p-${p.id || p.contacto_id}`,
      tipo: "Propietario",
      nombre: [p.nombre, p.apellidos].filter(Boolean).join(" ").trim() || p.nombre,
      telefono: p.telefono,
      email: p.email,
      extra: p.porcentaje != null && p.porcentaje !== "" ? `${p.porcentaje}%` : null,
      esComunicacion:
        p.es_comunicacion === true ||
        (comId && p.contacto_id && String(p.contacto_id) === String(comId)),
    })),
    ...contactos.map((c) => ({
      key: `c-${c.id || c.contacto_id}`,
      tipo: "Contacto asoc.",
      nombre: [c.nombre, c.apellidos].filter(Boolean).join(" ").trim() || c.nombre,
      telefono: c.telefono,
      email: c.email,
      extra: c.rol || null,
      esComunicacion:
        c.es_comunicacion === true ||
        (comId && c.contacto_id && String(c.contacto_id) === String(comId)),
    })),
  ];

  if (!filas.length) {
    return (
      <p className="text-sm px-1" style={{ color: t.textMuted }}>
        Sin propietarios ni contactos asociados.
      </p>
    );
  }

  const thSt = {
    textAlign: "left",
    padding: "6px 8px",
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: t.textMuted,
    borderBottom: `1px solid ${t.border}`,
  };
  const tdSt = {
    padding: "8px 8px",
    fontSize: 14,
    color: t.textPrimary,
    borderBottom: `1px solid ${t.border}`,
    verticalAlign: "middle",
  };

  return (
    <div className="overflow-x-auto">
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ ...thSt, width: 44, textAlign: "center" }} title="Contacto para comunicación">
              Com.
            </th>
            <th style={thSt}>Tipo</th>
            <th style={thSt}>Nombre</th>
            <th style={thSt}>Teléfono</th>
            <th style={thSt}>Email</th>
            <th style={thSt}>% / Rol</th>
          </tr>
        </thead>
        <tbody>
          {filas.map((f) => (
            <tr key={f.key}>
              <td style={{ ...tdSt, textAlign: "center" }}>
                <input
                  type="radio"
                  readOnly
                  checked={!!f.esComunicacion}
                  tabIndex={-1}
                  title={f.esComunicacion ? "Lleva la comunicación" : "No es el contacto de comunicación"}
                  aria-label={f.esComunicacion ? "Lleva la comunicación" : "No lleva la comunicación"}
                  style={{
                    width: 18,
                    height: 18,
                    margin: 0,
                    cursor: "default",
                    accentColor: "#2563eb",
                    pointerEvents: "none",
                  }}
                />
              </td>
              <td style={{ ...tdSt, color: t.textSecondary, fontSize: 13 }}>{f.tipo}</td>
              <td style={{ ...tdSt, fontWeight: 600 }}>{f.nombre || "—"}</td>
              <td style={tdSt}>{f.telefono || "—"}</td>
              <td style={tdSt}>{f.email || "—"}</td>
              <td style={{ ...tdSt, color: t.textSecondary }}>{f.extra || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
